// extracted by mini-css-extract-plugin
module.exports = {"imageFon":"ProfileInfo_imageFon__1u7eO","imageAvatar":"ProfileInfo_imageAvatar__3RTQE"};